import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/project/components/modal/modal.service';
import { PointReminderModalComponent } from './point-reminder-modal.component';
import { TReminderModalData } from './point-reminder-modal.consts';

@Injectable({
  providedIn: 'root',
})
export class PointReminderModalService {
  constructor(
    private modalService: ModalService,
    private router: Router,
  ) {}

  showReminderModal(modalData: TReminderModalData): void {
    this.modalService.setData(modalData);

    this.modalService.showModal(PointReminderModalComponent, {
      onClose: (resetUrl: boolean) => {
        if (!resetUrl) {
          return;
        }

        this.router.navigate([], {
          queryParams: {
            reminderId: null,
          },
          queryParamsHandling: 'merge',
        });
      },
    });
  }
}
